import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Modal, Input, message } from "antd";
import { RoutingURL } from "../../model/models";
import "./Settings.css";
import {SquareTile} from "../../components/home/squareTile/SquareTile";


import {
    FileOutlined,
    NumberOutlined,
    UserOutlined,
    DeleteOutlined
} from "@ant-design/icons";
import {HttpService} from "../../services/http/Http.service";
import {EnvService} from "../../services/Env.service";

export default function Settings() {
    const navigate = useNavigate();

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [confirmationWord, setConfirmationWord] = useState("");
    const [typedWord, setTypedWord] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const randomWords = ["CONFERMA", "CANCELLA", "ELIMINA", "TEST", "AFFERMATIVO"];


    const generateRandomWord = () => {
        const randomIndex = Math.floor(Math.random() * randomWords.length);
        return randomWords[randomIndex];
    };

    const showConfirmModal = () => {
        const word = generateRandomWord();
        setConfirmationWord(word);
        setTypedWord("");
        setIsModalVisible(true);
    };

    const handleOk = async () => {
        if (typedWord !== confirmationWord) {
            message.error("Parola di conferma errata. Riprova.");
            return;
        }

        setIsLoading(true);
        try {
            await HttpService.getInstanceAxios().post("/admin/clear-database");
            message.success("Database pulito con successo!");
            setIsModalVisible(false);
        } catch (error: any) {
            console.error("Errore durante la pulizia del database:", error);
            message.error("Errore durante la pulizia del database: " + (error.response?.data?.message || error.message));
        } finally {
            setIsLoading(false);
        }
    };

    const handleCancel = () => {
        setIsModalVisible(false);
        setTypedWord("");
    };

    const onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setTypedWord(e.target.value);
    };

    return (
        <>
        <Row gutter={[16, 16]} justify="center" className="home-container">
            <Col span={10}>
                <SquareTile
                    title="Moduli"
                    description="Gestione moduli ATS."
                    icon={<FileOutlined/>}
                    onCLick={() => navigate(RoutingURL.MODULES)}
                />
            </Col>
            <Col span={10}>
                <SquareTile
                    title="Variabili di calcolo"
                    description="Gestione delle variabili di calcolo."
                    icon={<NumberOutlined/>}
                    onCLick={() => navigate(RoutingURL.VARIABLES)}
                />
            </Col>
            <Col span={10}>
                <SquareTile
                    title="Gestione utenti"
                    description="Gestione degli utenti della piattaforma."
                    icon={<UserOutlined/>}
                    onCLick={() => navigate(RoutingURL.USERS)}
                />
            </Col>
            {EnvService.isTestEnvironment() && (
                <Col span={10}>
                    <SquareTile
                        title="Pulisci Database"
                        description="Operazione di pulizia del database (solo per test)."
                        icon={<DeleteOutlined style={{ color: 'red' }} />}
                        onCLick={showConfirmModal}
                        className="danger-tile"
                    />
                </Col>
            )}
        </Row>

            <Modal
                title="Conferma Pulizia Database"
                open={isModalVisible}
                onOk={handleOk}
                onCancel={handleCancel}
                confirmLoading={isLoading}
                okText="Conferma Pulizia"
                cancelText="Annulla"
                okButtonProps={{ danger: true }}
                maskClosable={false}
            >
                <p>
                    Questa operazione <strong>eliminerà definitivamente</strong> i dati nel database.
                    Questa azione è irreversibile.
                </p>
                <p>
                    Per confermare, digita la parola "
                    <strong style={{ color: 'red' }}>{confirmationWord}</strong>" nel campo sottostante:
                </p>
                <Input
                    value={typedWord}
                    onChange={onInputChange}
                    placeholder={`Digita "${confirmationWord}" per confermare`}
                    onPressEnter={handleOk}
                />
            </Modal>
        </>
    );
}
